import { render } from "./LocationReminder.vue?vue&type=template&id=1b83aca7"
import script from "./LocationReminder.vue?vue&type=script&lang=js"
export * from "./LocationReminder.vue?vue&type=script&lang=js"

import "./LocationReminder.vue?vue&type=style&index=0&id=1b83aca7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__